import { inject, Injectable } from '@angular/core';
import { ICompanyRegistrationRequest } from '@okcargo-apps/shared-domain';
import { ApiService } from '../api/api.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CompanyRegistrationService {
  private readonly apiService = inject(ApiService);

  private readonly _registrationUrl = '/service/command-processor/api/integrations/company-registry';

  public async register(request: ICompanyRegistrationRequest): Promise<void> {
    await firstValueFrom(this.apiService.post(this._registrationUrl, request, { observe: 'response' }, false));
  }
}
